import { type INewbuildingsPlusBlocksPikContractSchema } from 'shared/repositories/special-promos/entities/newbuildings_plus_blocks_pik_contract/NewbuildingsPlusBlocksPikContractSchema';
import { type IBanner } from 'shared/types/banners';
import {
  type MainCarouselBadge,
  type MainCarouselBanner,
  type MainCarouselIntervals,
  type MainCarouselSlidesDuration,
} from 'shared/types/mainCarousel';
import { extractUndefined } from 'shared/utils/extractUndefined';

type PrepareCarouselBannersParams = {
  bannersByRegionId: IBanner[];
  newbuildingsPlusBlocksPik: INewbuildingsPlusBlocksPikContractSchema[];
  slidesDuration: MainCarouselSlidesDuration;
};

export function prepareCarouselBanners({
  bannersByRegionId,
  newbuildingsPlusBlocksPik,
  slidesDuration,
}: PrepareCarouselBannersParams): [MainCarouselBanner[], MainCarouselIntervals] {
  const newbuildingsPlusBlocksPikMap = new Map(newbuildingsPlusBlocksPik.map(pik => [pik.newbuildingId, pik]));

  const carouselBanners = Array.of<MainCarouselBanner>();
  const carouselIntervals: MainCarouselIntervals = {
    // По умолчанию баннер показываем 4 секунды.
    default: slidesDuration.imageSlide,
  };

  bannersByRegionId.forEach((banner, index) => {
    const badges = Array.of<MainCarouselBadge>();

    if (newbuildingsPlusBlocksPikMap.has(banner.jkId)) {
      badges.push('seriaPlus');
    }

    const carouselBanner: MainCarouselBanner = {
      ...banner,
      badges,
      disclaimer: extractUndefined(banner.disclaimer),
      hasCommercialProperty: !!banner.hasCommercialProperty,
      label: extractUndefined(banner.label),
      logoUrl: extractUndefined(banner.logoUrl),
      video: extractUndefined(banner.video),
    };

    carouselBanners.push(carouselBanner);

    if (index === 0 && carouselBanner.video) {
      carouselIntervals[index] = slidesDuration.videoFirstSlide;
    } else if (carouselBanner.video) {
      carouselIntervals[index] = slidesDuration.videoSlide;
    }
  });

  return [carouselBanners, carouselIntervals];
}
